import { useState } from "react";
import { Box, Grid, Modal, Typography } from "@mui/material";
import { ModalDeviceParam } from "../../../types";
import ButtonCustom from "../../../components/Buttons/ButtonCustom";
import Loader from "../../../components/Loader";

interface ModalConfirmExtractionProps {
  item: ModalDeviceParam;
  isLoading: boolean;
  setItem: (value: ModalDeviceParam | null) => void;
  onSubmit: () => void;
}

const ModalConfirmExtraction: React.FC<ModalConfirmExtractionProps> = ({
  item,
  isLoading,
  setItem,
  onSubmit,
}) => {
  const [step, setStep] = useState<number>(0);

  const handleSubmit = () => {
    if (item?.option?.onSubmit) item?.option?.onSubmit();
    onSubmit();

    setStep(1);
  };

  if (isLoading) return <Loader />;

  return (
    <div>
      <Modal
        open={!!item}
        onClose={() => setItem(null)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: "20px",
            minWidth: 300,
            px: 2,
            pt: 4,
          }}
        >
          {step === 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "1rem" }}>
                抽出量を変更しますか？
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  wordWrap: "break-word",
                  wordBreak: "break-all",
                }}
              >
                対象：{item?.item?.thingNickname}
              </Typography>
              <Typography sx={{ fontSize: "0.8rem", fontWeight: 600, my: 2 }}>
                {item?.option?.volume}ml　→　{item?.option?.newVolume}ml
              </Typography>
              <Typography sx={{ fontSize: "0.7rem", textAlign: "center" }}>
                抽出量は一度変更してから1分以上経過後に変更してください。システムの不具合に繋がります。
              </Typography>

              <Grid
                sx={{
                  my: 2,
                  display: "flex",
                  justifyContent: "end",
                  width: 1,
                }}
              >
                <ButtonCustom
                  type="button"
                  sx={{ color: "#000", fontSize: "0.8rem" }}
                  onClick={() => setItem(null)}
                >
                  キャンセル
                </ButtonCustom>
                <ButtonCustom
                  type="button"
                  sx={{ color: "#9F1831", fontSize: "0.8rem" }}
                  onClick={handleSubmit}
                >
                  変更
                </ButtonCustom>
              </Grid>
            </Box>
          )}
          {step === 1 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                pb: 2,
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "1rem" }}>
                抽出量を変更しました
              </Typography>
              <Typography
                sx={{
                  fontSize: "0.8rem",
                  fontWeight: 600,
                  wordWrap: "break-word",
                  wordBreak: "break-all",
                  my: 1,
                }}
              >
                対象：{item?.item?.thingNickname}
              </Typography>
              <Typography sx={{ fontSize: "0.7rem" }}>
                抽出量を変更しました。反映に時間がかかる場合はあります。
              </Typography>

              <Grid sx={{ display: "flex", justifyContent: "center" }}>
                <ButtonCustom
                  type="button"
                  sx={{ color: "#9F1831", fontSize: "0.8rem", fontWeight: 600 }}
                  onClick={() => {
                    setStep(0);
                    setItem(null);
                  }}
                >
                  ok
                </ButtonCustom>
              </Grid>
            </Box>
          )}
        </Box>
      </Modal>
    </div>
  );
};
export default ModalConfirmExtraction;
